'use client'
import { useMediaQuery } from '@icouldeat/core'
import * as ScrollArea from '@radix-ui/react-scroll-area'
import { tv, type VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		root: 'overflow-hidden mr-1 print:overflow-visible',
		viewport: 'h-full w-full print:!overflow-visible',
		scrollbar: 'w-1 flex select-none touch-none bg-primary-light rounded-lg',
		thumb: 'flex-1 bg-primary-neutral rounded-lg relative',
	},
	variants: {
		internal: {
			true: {
				root: 'md:h-[calc(100vh-160px)]',
			},
		},
	},
})

interface ScrollableProps extends VariantProps<typeof styles> {
	className?: string
	children: React.ReactNode
}

// Interface for scrollable content in the dashboard
export const ScrollableArea = ({ className, children, internal = false }: ScrollableProps) => {
	const isMobile = useMediaQuery('(max-width: 1024px)')

	const { root, viewport, scrollbar, thumb } = styles({ internal })

	if (isMobile) {
		return <section>{children}</section>
	}

	return (
		<ScrollArea.Root type='auto' className={`${root()} ${className}`}>
			<ScrollArea.Viewport className={viewport()}>{children}</ScrollArea.Viewport>
			<ScrollArea.Scrollbar orientation='vertical' className={scrollbar()}>
				<ScrollArea.Thumb className={thumb()} />
			</ScrollArea.Scrollbar>
			<ScrollArea.Corner />
		</ScrollArea.Root>
	)
}

export default ScrollableArea
